"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMEZONE_PREFERENCES_COOKIE = exports.LOCALIZED_CATEGORY_LOCALE_PREFERENCE_COOKIE = exports.LOCALE_PREFERENCES_COOKIE = void 0;
const universal_cookie_1 = __importDefault(require("universal-cookie"));
const log_1 = require("../../log");
exports.LOCALE_PREFERENCES_COOKIE = 'LithiumLocalePreferences';
exports.LOCALIZED_CATEGORY_LOCALE_PREFERENCE_COOKIE = 'LithiumLocalizedCategoryLocalePreference';
exports.TIMEZONE_PREFERENCES_COOKIE = 'LithiumTimezonePreferences';
const PREFERENCES_COOKIE_PATH = '/';
const log = (0, log_1.getLog)(module);
function getCookies(cookie) {
    return new universal_cookie_1.default(cookie);
}
/**
 * Options for the cookie.
 */
function getCookieOptions() {
    const expires = new Date();
    // expire in 24 hs
    expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000);
    return {
        httpOnly: false,
        path: PREFERENCES_COOKIE_PATH,
        expires,
        sameSite: 'lax'
    };
}
/**
 * Helper for working with i18n cookies.
 */
const IntlCookieHelper = {
    /**
     * Retrieve the locale data from cookie.
     *
     * @returns the data stored in cookie, null otherwise
     */
    getLocaleFromCookie(request) {
        return getCookies(request === null || request === void 0 ? void 0 : request.cookies).get(exports.LOCALE_PREFERENCES_COOKIE);
    },
    /**
     * Retrieve the localized category locale data from cookie.
     *
     * @returns the data stored in cookie, null otherwise
     */
    getLocaleFromLocalizedCategoryLocaleCookie(request) {
        return getCookies(request === null || request === void 0 ? void 0 : request.cookies).get(exports.LOCALIZED_CATEGORY_LOCALE_PREFERENCE_COOKIE);
    },
    /**
     * Retrieves the timezone from the cookie.
     * @param request - The request object containing the cookies.
     * @returns The timezone preference value from the cookie.
     */
    getTimezoneFromCookie(request) {
        return getCookies(request === null || request === void 0 ? void 0 : request.cookies).get(exports.TIMEZONE_PREFERENCES_COOKIE);
    },
    /**
     * Persist locale data on cookie and reduce network calls to fetch language.
     *
     * @param locale the locale to persist
     * @param response the response if on the server
     */
    setLocaleCookie(locale, response) {
        const options = getCookieOptions();
        log.debug('Setting %s cookie with value %s and options %O', exports.LOCALE_PREFERENCES_COOKIE, locale, options);
        if (response) {
            response.cookie(exports.LOCALE_PREFERENCES_COOKIE, locale, options);
        }
        else {
            getCookies().set(exports.LOCALE_PREFERENCES_COOKIE, locale, options);
        }
    },
    /**
     * Update current localized category locale cookie with new locale
     * @param locale
     */
    setLocalizedCategoryLocaleCookie(locale) {
        const cookieOptions = getCookieOptions();
        getCookies().set(exports.LOCALIZED_CATEGORY_LOCALE_PREFERENCE_COOKIE, locale, cookieOptions);
    },
    /**
     * Persist timezone data on cookie to reduce network calls to fetch timzone.
     *
     * @param timeZone the timeZone to persist
     * @param response the response if on the server
     */
    setTimezoneCookie(timeZone, response) {
        const cookieOptions = getCookieOptions();
        log.debug('Setting %s cookie with value %s and options %O', exports.TIMEZONE_PREFERENCES_COOKIE, timeZone, cookieOptions);
        if (response) {
            response.cookie(exports.TIMEZONE_PREFERENCES_COOKIE, timeZone, cookieOptions);
        }
        else {
            getCookies().set(exports.TIMEZONE_PREFERENCES_COOKIE, timeZone, cookieOptions);
        }
    }
};
exports.default = IntlCookieHelper;
//# sourceMappingURL=IntlCookieHelper.js.map